import { Component, Input } from '@angular/core';
import { DynamicFlowContent } from '../../model/dynamic-flow.types';

@Component({
  selector: 'c-content-step',
  imports: [],
  templateUrl: './content-step.component.html',
  styleUrl: './content-step.component.scss',
})
export class ContentStepComponent {
  @Input() content: DynamicFlowContent;
}
